import React, { useState, useEffect } from 'react'
import logo from '../Images/kuza-new.svg'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight, faBars, faTimes } from '@fortawesome/free-solid-svg-icons'

function NavBar2() {
  const [activeLink, setActiveLink] = useState('home')
  const [showMobileMenu, setShowMobileMenu] = useState(false)

  const handleToggleMobile = () => setShowMobileMenu(!showMobileMenu)

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['home', 'about', 'features', 'downloads', 'contact']
      let current = 'home'
      for (let id of sections) {
        const section = document.getElementById(id)
        if (section) {
          const rect = section.getBoundingClientRect()
          if (rect.top <= 80 && rect.bottom >= 80) {
            current = id
            break
          }
        }
      }
      setActiveLink(current)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <div className='navBarMain navbar-expand-lg bg-white px-5 py-3 d-flex align-items-center justify-content-between'>

      <Link  to="/">
        <img src={logo} className='logo' alt="Logo" />
      </Link>
      

      {/* Desktop Menu */}
      <ul className="navbar-nav d-none d-lg-flex flex-row gap-3 webmenu">
        
      </ul>

      {/* Right Actions */}
      <ul className='navbar-nav d-flex flex-row gap-3 align-items-center'>
        <li className='listitems d-none d-lg-block'>
          <Link className='menuItem' to="/signin">Login</Link>
        </li>
        <li className='listitems'>
          <Link className='menuItem signup' to="/signin">
            Register <FontAwesomeIcon icon={faArrowRight} className="laftNavIcon" />
          </Link>
        </li>
        
      </ul>

      {/* Mobile Menu */}
      {showMobileMenu && (
        <div className="mobile-menu d-lg-none mt-3">
          <ul className="navbar-nav flex-column text-center gap-3">
            {['home', 'about', 'features', 'downloads', 'contact'].map((id) => (
              <li className="nav-item" key={id}>
                <a
                  className={`nav-link ${activeLink === id ? 'active' : ''}`}
                  href={id === 'home' ? '#' : `#${id}`}
                  onClick={() => setShowMobileMenu(false)}
                >
                  {id === 'home'
                    ? 'Home'
                    : id === 'about'
                    ? 'About Us'
                    : id === 'features'
                    ? 'How it Works'
                    : id === 'downloads'
                    ? 'Downloads'
                    : 'Contact us'}
                </a>
              </li>
            ))}
            <li>
              <Link className='menuItem' to="/signin" onClick={() => setShowMobileMenu(false)}>Login</Link>
            </li>
            <li>
              <Link className='menuItem signup' to="/signin" onClick={() => setShowMobileMenu(false)}>
                Register <FontAwesomeIcon icon={faArrowRight} className="laftNavIcon" />
              </Link>
            </li>
          </ul>
        </div>
      )}
    </div>
  )
}

export default NavBar2